import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  inventoryControllerCancel,
  inventoryControllerCreate,
  InventoryControllerCreate$Params,
  inventoryControllerFindAll,
  InventoryControllerFindAll$Params,
  inventoryControllerFindById,
  inventoryControllerSubmit,
  InventoryControllerSubmit$Params,
} from '@klubovna/api-client';
import { CreateInventoryCountDto, InventoryCount, SubmitInventoryCountDto } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InventoryCountsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: InventoryControllerFindAll$Params): Observable<PaginatedResponse<InventoryCount>> {
    return inventoryControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<InventoryCount>(response.body)));
  }

  findById(id: string): Observable<InventoryCount> {
    return inventoryControllerFindById(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as InventoryCount));
  }

  create(data: CreateInventoryCountDto): Observable<InventoryCount> {
    const params: InventoryControllerCreate$Params = { body: data };
    return inventoryControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as InventoryCount));
  }

  submit(id: string, data: SubmitInventoryCountDto): Observable<InventoryCount> {
    const params: InventoryControllerSubmit$Params = { id, body: data };
    return inventoryControllerSubmit(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as InventoryCount));
  }

  cancel(id: string): Observable<InventoryCount> {
    return inventoryControllerCancel(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as InventoryCount));
  }
}
